'use strict';

function service($http, $q, $location) {
    return function (url) {
        let defer = $q.defer();
        let config = {};
        config.params = $location.$$search;
        $http.get(api+url, config)
            .then(function (result) {
                if (typeof result.data.rows !== "undefined") {
                    defer.resolve(result.data.rows);
                } else {
                    defer.resolve(result.data);
                }
            },
            function (err) {
                defer.reject(err);
            })
        return defer.promise;
    }
}

service.$inject = ['$http', '$q', '$location'];
module.exports = service;


/** WEBPACK FOOTER **
 ** ./src/pages/services/fetchdata.js
 **/